import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchJobType() {
  try {
    const res = await apiAxios.get(`/jobs/types`);
    return res.data.data;
  } catch (e) {
    console.log(e);
  }
}

function useJobTypeData() {
  const { user: userState } = useContext(LoginStateContext);

  return useQuery(["job-type"], fetchJobType, {
    enabled: userState.isLoggedIn,
  });
}

export default useJobTypeData;
